export enum SortingDirection {
  Ascending = 'asc',
  Descending = 'desc',
}

export default interface SortingOptions<T = Record<string, never>> {
  sortBy: keyof T;
  direction: SortingDirection;
}
